export const KEY_INITIATIVES_TABS_ELEMENT_ID = 'P360Tabs'
export const KEY_INITIATIVES_TAB_ID = '21'
export const KEY_INITIATIVES_TAB_PARAM = 'jbp-tab'
export const KEY_INITIATIVES_SCROLL_OFFSET = 150
